import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { placeBetSaga } from './placeBetSaga';
import { cancelAllBetsSaga } from './cancelAllBetsSaga';
import { cancelLastBetSaga } from './cancelLastBetSaga';
import { commissionModeRootSaga } from '../CommissionMode/sagas/root';

export function* betRootSaga() {
  yield all([
    takeEvery(ACTIONS.PLACE_BET, placeBetSaga),
    takeEvery(ACTIONS.CANCEL_ALL_BETS, cancelAllBetsSaga),
    takeEvery(ACTIONS.CANCEL_LAST_BET, cancelLastBetSaga),
    commissionModeRootSaga(),
  ]);
}
